import { createContext, useContext } from 'react';
const TokensContext = createContext(null);
export const TokensProvider = TokensContext.Provider;
export const useTokens = () => {
    const tokens = useContext(TokensContext);
    if (!tokens) {
        throw new Error('Tokens cannot be null, please add a context provider.');
    }
    return tokens;
};
//# sourceMappingURL=TokensProvider.js.map